import React from 'react';
import Flagship from '../../core/flagship';
import Field from '../records/Field';
import {connect} from 'react-redux';
import { Table, Loader, Header, Modal, Button, Select, Icon } from 'semantic-ui-react';
import {shouldShowField, empty} from '../../utils/helpers';

class LineItemForm extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = this.getInitialState();
        this.editName = this.editName.bind(this);
        this.onSelectService = this.onSelectService.bind(this);
        this.onSelectSubOption = this.onSelectSubOption.bind(this);
        this.getSubServiceFields = this.getSubServiceFields.bind(this);
        this.saveAndExit = this.saveAndExit.bind(this);
        this.addError = this.addError.bind(this);
        this.clearError = this.clearError.bind(this);
        this.onChange = this.onChange.bind(this);
    }

    getInitialState() {
        return {
            lineItemForm: [],
            lineItemData: {},
            lineItemPricingFields: [],
            editingName: false,
            errors: [],
            newLineItemService: null,
            newLineItemName: null,
            newLineItemServiceNiceName: null,
            mainService: null,
            subOptions: null
        };
    }

    onChange(e, data, fieldId) {

        let lineItemData = Object.assign({}, this.state.lineItemData);
        lineItemData[fieldId] = data;

        this.setState({
           lineItemData: lineItemData
        });

        if (typeof this.props.onChange === "function") {
            this.props.onChange(lineItemData);
        }
    }

    editName() {
        this.setState({
            editingName: true
        });
    }

    onLineItemNameChange(newName) {
        this.setState(
            {
                newLineItemName: newName
            }
        );
    }

    onSelectService(e, data) {

        let service = data.value;
        let configItem = Flagship.config.lineItemServices.find(function(element) {
            return element.value === service;
        });

        if (configItem.hasOwnProperty("subOptions")) {
            this.setState({
               mainService: configItem,
               subOptions:  configItem.subOptions
            });
        } else {
            service = configItem.text;

            this.setState({
                newLineItemService: data.value,
                newLineItemServiceNiceName: service,
                newLineItemName: service
            }, function() {

                let self = this;

                Flagship.get(
                    'line-item-form/' + this.state.newLineItemService,
                    {
                        withData: (typeof this.props.lineItemId === "undefined" ? false : this.props.lineItemId)
                    },
                    function (response) {

                        if (response.data.success === true) {

                            self.setState({
                                lineItemForm: response.data.results
                            });

                        } else {

                            Flagship.error(
                                "Error getting line item form from Flagship API server.",
                                self.props.recordId,
                                self.props.userId
                            );
                        }
                    },
                    function (err) {

                        Flagship.error(
                            "Error getting line item form from Flagship API server: " + err,
                            self.props.recordId,
                            self.props.userId
                        );
                    }
                );
            });
        }
    }

    onSelectSubOption(e, data) {
        let subService = data.value;
        let configItem = this.state.mainService.subOptions.find(function(element) {
            return element.value === subService;
        });

        let service = this.state.mainService.text + ' - ' + configItem.text;

        this.setState({
            newLineItemService: data.value,
            newLineItemServiceNiceName: service,
            newLineItemName: service
        }, function() {

            let self = this;

            // First get main service fields
            Flagship.get(
                'line-item-form/' + this.state.mainService.value,
                {
                    withData: (typeof this.props.lineItemId === "undefined" ? false : this.props.lineItemId)
                },
                function (response) {

                     if (response.data.success === true) {

                        self.setState({
                            lineItemForm: response.data.results
                        }, function () {
                            self.getSubServiceFields();
                        });

                    } else {

                        Flagship.error(
                            "Error getting line item form from Flagship API server.",
                            self.props.recordId,
                            self.props.userId
                        );
                    }
                },
                function (err) {

                    Flagship.error(
                        "Error getting line item form from Flagship API server: " + err,
                        self.props.recordId,
                        self.props.userId
                    );
                }
            );

        });
    }

    getSubServiceFields() {

        let self = this;

        // Then add sub service fields
        Flagship.get(
            'line-item-form/' + this.state.newLineItemService,
            {
                withData: (typeof this.props.lineItemId === "undefined" ? false : this.props.lineItemId)
            },
            function (response) {

                if (response.data.success === true) {

                    let combinedForm = [...response.data.results, ...self.state.lineItemForm];

                    combinedForm.sort(function(a,b) {return (a.order > b.order) ? 1 : ((b.order > a.order) ? -1 : 0);} );

                    self.setState({
                        lineItemForm: combinedForm
                    });

                } else {

                    Flagship.error(
                        "Error getting line item form from Flagship API server.",
                        self.props.recordId,
                        self.props.userId
                    );
                }
            },
            function (err) {

                Flagship.error(
                    "Error getting line item form from Flagship API server: " + err,
                    self.props.recordId,
                    self.props.userId
                );
            }
        );
    }


    addError(fieldId) {

        let errors = this.state.errors;

        if (errors.indexOf(fieldId) !== -1) {
            errors.push(fieldId);
        }

        this.setState({
            errors: errors
        });
    }

    clearError(fieldId) {

        let errors = this.state.errors;
        for(var i = errors.length - 1; i >= 0; i--) {
            if(errors[i] === fieldId) {
                errors.splice(i, 1);
            }
        }

        this.setState({
            errors: errors
        });
    }

    saveAndExit() {

        let self = this;

        Flagship.post(
            "line-item/create/" + self.props.recordId,
            {
                line_item_name: self.state.newLineItemName,
                line_item_type: self.state.newLineItemService,
                data: self.state.lineItemData
            },
            function(response) {
                if (response.data.success === true) {
                    Flagship.notify("Line item created.","success");
                    Flagship.event(
                        "create-line-item",
                        {
                            lineItemId: response.data.lineItemId,
                            lineItemKey: response.data.line_item_key,
                            lineItemName: self.state.newLineItemName,
                            lineItemType: self.state.newLineItemService,
                            data: self.state.lineItemData
                        },
                        self.props.recordId,
                        self.props.userId
                    );
                    self.setState(self.getInitialState(), function() {

                        if (typeof self.props.onAddLineItem === "function") {
                            self.props.onAddLineItem();
                        }
                    });
                } else {
                    Flagship.error("Error adding line item.", self.props.recordId, self.props.userId);
                }
            }, function(err) {
                Flagship.error("Error adding line item: " + err, self.props.recordId, self.props.userId);
            }
        );
    }

    render() {

        if(empty(this.state.lineItemForm)) {
            return (
                <Table>
                    <Table.Body>
                        <Table.Row>
                            <Table.Cell colSpan="5">
                                <Loader className="flagship-loader" active inline='centered' />
                            </Table.Cell>
                        </Table.Row>
                    </Table.Body>
                </Table>
            );
        } else {

            let self = this;
            let serviceOptions = JSON.parse(JSON.stringify(Flagship.config.lineItemServices));
            serviceOptions = serviceOptions.map(function(item) {
                if (item.hasOwnProperty("subOptions")) {
                    delete item["subOptions"];
                }
                return item;
            });

            return (
                <Modal
                    open={true}
                    onClose={this.props.cancelAddNew}
                    closeIcon
                >
                    <Header icon='pin' content='Add New Line Item' />
                    <Modal.Content>

                        {this.state.newLineItemService === null ?
                            <div>
                                <p>Add a line item for each service that should receive pricing.</p>
                                <Select
                                    style={{marginRight:"5px"}}
                                    placeholder="Select a Service"
                                    options={serviceOptions}
                                    onChange={(e, data) => {self.onSelectService(e, data)}}
                                />
                                {this.state.subOptions !== null ?
                                <Select
                                    placeholder="Specific Service"
                                    options={this.state.subOptions}
                                    onChange={(e, data) => {self.onSelectSubOption(e, data)}}
                                /> : null }
                            </div>
                            :
                            <div>
                                {this.state.editingName === true ?
                                    <Header as="h3" color="grey">
                                        <div className="ui input">
                                            <input
                                                autoFocus
                                                placeholder={self.state.newLineItemName}
                                                onChange={self.props.onLineItemNameChange}
                                                style={
                                                    {
                                                        minWidth: '400px',
                                                        maxWidth: '100%'
                                                    }
                                                }
                                            />
                                        </div>
                                        <span className="margin-left">{' (' + this.state.newLineItemServiceNiceName + ')'}</span>
                                    </Header>:
                                    <Header as="h3" onClick={self.editName} className="hover-dotted-outline">
                                        {self.state.newLineItemName +
                                        (self.state.newLineItemName !== this.state.newLineItemServiceNiceName ?
                                                '(' + this.state.newLineItemServiceNiceName + ')' :
                                                ''
                                        )
                                        }
                                    </Header>
                                }
                                {this.state.lineItemForm.map(function(item, i) {

                                    let fieldId = item.id;
                                    return( shouldShowField( item, self.state.lineItemData) ?
                                            <Field
                                                contentType="lineItem"
                                                addError={self.addError}
                                                clearError={self.clearError}
                                                model={"LineItem." + i}
                                                key={'field-' + i}
                                                value={!empty( item.value ) ? item.value : null}
                                                default={self.state.lineItemData[fieldId]}
                                                filterInput={item.validation !== '' ? item.validation : null}
                                                onChange={(e, data, fieldId) => self.onChange(e, data, fieldId)}
                                                {...item} />
                                            : null
                                    );
                                })}
                            </div>}
                    </Modal.Content>
                    <Modal.Actions>
                        <Button disabled={this.state.newLineItemService === null} primary onClick={this.saveAndExit}>
                            <Icon name='plus' /> Add Line Item
                        </Button>
                        <Button color='grey' onClick={this.props.cancelAddNew}>
                            <Icon name='dont' /> Cancel
                        </Button>
                    </Modal.Actions>
                </Modal>

            );

        }
    }
}

function mapStateToProps(state) {
    return {
        username: state.main.username,
        userId: state.main.userId,
        userRole: state.main.userRole
    };
}

export default connect(
    mapStateToProps,
    null
)(LineItemForm);


// WEBPACK FOOTER //
// ./src/components/modals/LineItemAddModal.js